import { Handshake } from "lucide-react";

const manifest = {
  key: "negotiation_award_management",
  isFreeModule: false,
  isPurchasable: true,
  icon: Handshake,
  names: {
    plan: {
      en: "Negotiation & Award Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u062a\u0641\u0627\u0648\u0636 \u0648\u0627\u0644\u062a\u0631\u0633\u064a\u0629",
      "zh-Hans": "谈判与授标管理",
    },
    dashboard: {
      en: "Negotiation & Award Management",
      ar: "\u0625\u062f\u0627\u0631\u0629 \u0627\u0644\u062a\u0641\u0627\u0648\u0636 \u0648\u0627\u0644\u062a\u0631\u0633\u064a\u0629",
      "zh-Hans": "谈判与授标仪表板",
    },
  },
  defaultPath: "/negotiation-dashboard",
  matchers: [
    /^\/negotiation-dashboard(?:\/|$)/,
    /^\/incoming-negotiation-requests(?:\/|$)/,
    /^\/publisher-negotiation-responses(?:\/|$)/,
    /^\/negotiations\/[^/]+(?:\/|$)/,
    /^\/tenders-pending-awarding(?:\/|$)/,
    /^\/awarded-tenders(?:\/|$)/,
    /^\/tenders-awarded-to-me(?:\/|$)/,
    /^\/mytender\/[^/]+\/negotiation(?:\/|$)/,
    /^\/mytender\/[^/]+\/award(?:\/|$)/,
  ],
  buildNavbarMenus: ({ t, activeModuleLabel }) => [
    {
      label: activeModuleLabel,
      path: "__negotiation_awarding__",
      children: [
        { label: t("dashboard"), path: "/negotiation-dashboard" },
        {
          label:
            t("menu_incoming_negotiations_review") ||
            "Incoming Negotiations for Review",
          path: "/incoming-negotiation-requests",
          permissions: [
            "view_incoming_negotiations_for_review",
            "accept_negotiation",
            "submit_offers",
            "create_offers_draft",
          ],
        },
        {
          label:
            t("menu_negotiations_waiting_supplier_response") ||
            "Negotiations Waiting Supplier Response",
          path: "/publisher-negotiation-responses",
          permissions: ["view_pending_supplier_negotiations"],
        },
        {
          label:
            t("tenders_pending_awarding_title") || "Tenders Pending Awarding",
          path: "/tenders-pending-awarding",
          permissions: ["tenders_pending_awarding"],
        },
        {
          label: t("awarded_tenders_title") || "Awarded Tenders",
          path: "/awarded-tenders",
          permissions: ["view_award_approvals"],
        },
        {
          label:
            t("tenders_awarded_to_me_title") || "Tenders Awarded to Me",
          path: "/tenders-awarded-to-me",
          permissions: ["view_tenders_awarded_to_me", "view_award_approvals"],
        },
      ],
    },
  ],
};

export default manifest;
